import { CreditCardNetwork } from "chameleon/lib/components/display-cards/display-cards";

import { useChexContext } from "checkout-experience/providers/chex-context-wrapper";

import { CardNetwork } from "frontend-client";

export const useSupportedPaymentTypes = (currencyCode: string) => {
  const { merchantSettings } = useChexContext();

  const paymentMethods = merchantSettings?.paymentMethods;
  const acceptedCards = (
    paymentMethods?.cardPaymentMethod?.supportedCards ?? []
  )
    .filter(
      (m) =>
        !currencyCode ||
        m.pointOfSaleCurrencyCodes.length === 0 ||
        m.pointOfSaleCurrencyCodes.includes(currencyCode)
    )
    .map((m: { network: CardNetwork }) => m.network);

  return updateSupportedCardTypes(acceptedCards);
};

const updateSupportedCardTypes = (
  cards: Array<CardNetwork>
): Array<CreditCardNetwork> => {
  const supportedCards: Array<CreditCardNetwork> = [];

  for (const card of cards) {
    switch (card) {
      case CardNetwork.AMEX:
        supportedCards.push("amex");
        break;
      case CardNetwork.DISCOVER:
        supportedCards.push("discover");
        break;
      case CardNetwork.MASTERCARD:
        supportedCards.push("mastercard");
        break;
      case CardNetwork.MAESTRO:
        supportedCards.push("maestro");
        break;
      case CardNetwork.VISA:
        supportedCards.push("visa");
        break;
      case CardNetwork.JCB:
        supportedCards.push("jcb");
        break;
      case CardNetwork.CHINA_UNION_PAY:
        supportedCards.push("unionPay");
        break;
      case CardNetwork.DINERS:
        supportedCards.push("dinersClub");
        break;
    }
  }

  return supportedCards;
};
